import React from 'react';
import { NavLink } from 'react-router-dom';
// import {
//   LayoutDashboard,
//   BarChart3,
//   FileText,
//   User
// } from 'lucide-react';
// import { useAuth } from '../contexts/AuthContext';

interface NavigationItem {
  icon: React.ComponentType<{ size?: number }>;
  label: string;
  path: string;
}

const Sidebar: React.FC = () => {
  // const { user } = useAuth();

  const navigationItems: NavigationItem[] = [
    // { icon: LayoutDashboard, label: 'My Dashboard', path: '/dashboard' },  // Commented out - may use later
    // { icon: BarChart3, label: 'Analytics', path: '/analytics' },
    // { icon: FileText, label: 'Browse Cases', path: '/cases' },
  ];

  return (
    <div className="w-20 bg-neutral-900 text-white flex flex-col items-center py-4 space-y-6">
      {/* Logo */}
      <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center">
        <span className="text-white font-bold text-xl">C</span>
      </div>

      {/* Main Navigation */}
      <nav className="flex flex-col space-y-4">
        {navigationItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `w-12 h-12 flex items-center justify-center rounded-lg transition-colors group relative ${
                isActive
                  ? 'bg-primary text-white'
                  : 'text-neutral-400 hover:text-white hover:bg-neutral-800'
              }`
            }
          >
            <item.icon size={20} />
            <div className="absolute left-16 bg-neutral-800 text-white px-2 py-1 rounded text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
              {item.label}
            </div>
          </NavLink>
        ))}
      </nav>

      {/* User Indicator - commented out for now
      <div className="mt-auto">
        <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-neutral-800 group relative">
          <User size={20} className="text-neutral-400" />
          {user && (
            <div className="absolute left-16 bg-neutral-800 text-white px-3 py-2 rounded text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
              <div className="font-medium">{user.name}</div>
              <div className="text-xs text-neutral-400">{user.role}</div>
            </div>
          )}
        </div>
      </div>
      */}
    </div>
  );
};

export default Sidebar;
